export default __webpack_public_path__ + "static/media/rnr-sports-table-24.e017e73b.webp";